import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TrendStatisticResponse} from '@npck/af-frontend-api';
import {Spinner} from '@npck/libs/commons';
import dayjs, {Dayjs} from 'dayjs';
import {BehaviorSubject} from 'rxjs';
import {DateRangeForm} from '../../../../../../components/date-range-picker-field/date-range-picker-field.component';

@Component({
    selector: 'af-trend-statistic',
    templateUrl: './trend-statistic.component.html',
    styleUrl: './trend-statistic.component.scss',
    standalone: false,
})
export class TrendStatisticComponent implements OnInit {
    @Input() form: FormGroup<TrendStatisticForm>;
    @Input() trendStatistic: TrendStatisticResponse;
    @Input() formInitialized: BehaviorSubject<boolean>;
    Spinner = Spinner;
    maxDate = new Date();

    constructor(
        private cdr: ChangeDetectorRef,
        private formBuilder: FormBuilder,
    ) {
    }

    get periodDetectedFrom(): Dayjs {
        return dayjs(this.trendStatistic.periodDetectedFrom);
    }

    get periodDetectedTo(): Dayjs {
        return dayjs(this.trendStatistic.periodDetectedTo);
    }

    ngOnInit(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.form.addControl('id', new FormControl(this.trendStatistic?.id, [Validators.required]));
        this.form.addControl('country', new FormControl(this.trendStatistic?.country, [Validators.required]));
        this.form.addControl('region', new FormControl(this.trendStatistic?.region, [Validators.required]));
        this.form.addControl('incidentCount', new FormControl(this.trendStatistic?.incidentCount + '', [Validators.required]));
        this.form.addControl('uniqueVictimCount', new FormControl(this.trendStatistic?.uniqueVictimCount + '', [Validators.required]));
        this.form.addControl('isDeleted', new FormControl(this.trendStatistic?.isDeleted));
        this.form.addControl('periodRange', this.formBuilder.group({}));
    }
}

export interface TrendStatisticForm {
    id?: FormControl<string>;
    country?: FormControl<string>;
    region?: FormControl<string>;
    incidentCount?: FormControl<string>;
    uniqueVictimCount?: FormControl<string>;
    periodRange?: FormGroup<DateRangeForm>;
    isDeleted?: FormControl<boolean>;
}
